module.exports = __webpack_public_path__ + "media/images/apaxlogo-38a4dbee.png";